import { toast } from '@/components/ui/toaster.jsx';

// The text permission gate's shadow warnings (people-create-door T7c, DA1): a
// door that sent a text forwards the gate's `warnings` ({ code, message }) and
// every surface renders each one as its own toast.info, never console beside a
// success toast. Guard: tests/sms-doors-surface.test.js.
export function toastSmsWarnings(warnings) {
  (Array.isArray(warnings) ? warnings : []).forEach((w) => toast.info(typeof w === 'string' ? w : w?.message || w?.code || 'Text sent with a warning'));
}

// The permission word for a sheet's badge: the store's answer, never the form's checkbox.
export const PERMISSION_WORD = {
  granted: 'Text permission on record',
  none: 'No text permission on record',
  stopped_by_number: 'Texted STOP, sending blocked',
  unreadable: 'Could not check text permission',
};
export const PERMISSION_TONE = {
  granted: 'bg-success/15 text-success',
  none: 'bg-warning/15 text-warning',
  stopped_by_number: 'bg-danger/15 text-danger',
  unreadable: 'bg-warning/15 text-warning',
};
